import { useAllSettings } from '@/hooks/useKitchenFlowEnabled'
import { cateringOnKdsSwitchedOn, parseCateringOnKds } from '@/lib/cateringKds/cateringKdsLogic'
import type { CateringOnKdsSetting } from '@/lib/cateringKds/cateringKdsTypes'

export const CATERING_KDS_QK = ['kitchen', 'catering'] as const

/**
 * Whether the Kitchen Display shows its catering lane: the deploy runs the
 * kitchen flow AND the admin switched catering on. A missing key, a failed
 * fetch or anything unexpected reads as off — the board is then exactly what
 * it was, and makes no new request. Shares the ['settings','all'] cache.
 */
export function useCateringOnKds(): { enabled: boolean; setting: CateringOnKdsSetting } {
  const all = useAllSettings()
  return { enabled: cateringOnKdsSwitchedOn(all), setting: parseCateringOnKds(all) }
}
